import type { Option } from '@/legacy/types';
import { NonTranslatableText } from '@/shared/ui/NonTranslatableText';

export const markOptionsAsNonTranslatable = (options: Option[]): Option[] =>
	options.map((option) => ({
		...option,
		notTranslatable: true,
		renderLabel: option.renderLabel ?? <NonTranslatableText>{option.label}</NonTranslatableText>,
	}));
